import {Grid, TextField} from '@mui/material';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import {bool, func, string} from 'prop-types';

import {DEFAULT_PROJECTS_SCHEMAS} from '../../../../const';
import useReport from '../../../../hooks/providers/useReport';
import Checkbox from '../../../form/Checkbox/Checkbox';
import FormUppercaseLabel from '../../../form/FormUppercaseLabel/FormUppercaseLabel';
import FormSelect from '../../../form/MuiSelect/MuiSelect';
import CreateFromScratchOrCloneReportToggler from '../CreateFromScratchOrCloneReportToggler/CreateFromScratchOrCloneReportToggler';

const CreateReportForm = ({
  isCloningExistingReport,
  setIsCloningExistingReport,
  reportToClone = '',
  setReportToClone,
  reportName,
  setReportName,
  reportNameError,
  reportNameHelperText,
  reportSchema = '',
  setReportSchema
}) => {
  const {reports} = useReport();

  const getReportsListMenuItems = () => {
    const reportsList = reports.filter(r => r.available_to_clone);

    if (reportsList.length === 0) {
      return (
        <MenuItem>
          <ListItemText>Aucun rapport disponible</ListItemText>
        </MenuItem>
      );
    }

    return reportsList.map(r => {
      return (
        <MenuItem value={r.report_id} key={r.report_id}>
          <ListItemText>{r.report_name}</ListItemText>
        </MenuItem>
      );
    });
  };

  const reportsListMenuItems = getReportsListMenuItems();

  const handleCheckReportSchema = schema => {
    setReportSchema(schema);
  };

  return (
    <>
      <TextField
        required
        value={reportName}
        onChange={event => {
          setReportName(event.target.value);
        }}
        label="Nom"
        placeholder="Saisir le nom du nouveau rapport"
        color="primary"
        fullWidth
        error={reportNameError}
        helperText={reportNameHelperText}
      />

      <Box mt={4}>
        <CreateFromScratchOrCloneReportToggler isCloningExistingReport={isCloningExistingReport} setIsCloningExistingReport={setIsCloningExistingReport} />
      </Box>

      {isCloningExistingReport ? (
        <>
          <Box mt={2}>
            <FormUppercaseLabel label="Choisir le rapport modèle" />
          </Box>
          <FormSelect sx={{mt: 2}} label="Rapports" labelId="reports" value={reportToClone} onChange={e => setReportToClone(e.target.value)} items={reportsListMenuItems} />
        </>
      ) : (
        <>
          <Box mt={2}>
            <FormUppercaseLabel label="Choisir une source de données" />
          </Box>
          <Grid container>
            <Checkbox
              label="Comptabilité"
              value={DEFAULT_PROJECTS_SCHEMAS.gestion}
              checked={reportSchema === DEFAULT_PROJECTS_SCHEMAS.gestion}
              onChange={() => handleCheckReportSchema(DEFAULT_PROJECTS_SCHEMAS.gestion)}
            />
            <Checkbox
              label="Social"
              value={DEFAULT_PROJECTS_SCHEMAS.dsn}
              checked={reportSchema === DEFAULT_PROJECTS_SCHEMAS.dsn}
              onChange={() => handleCheckReportSchema(DEFAULT_PROJECTS_SCHEMAS.dsn)}
            />
            <Checkbox label="Caisse" value={DEFAULT_PROJECTS_SCHEMAS.z} checked={reportSchema === DEFAULT_PROJECTS_SCHEMAS.z} onChange={() => handleCheckReportSchema(DEFAULT_PROJECTS_SCHEMAS.z)} />
          </Grid>
        </>
      )}
    </>
  );
};

CreateReportForm.propTypes = {
  isCloningExistingReport: bool.isRequired,
  reportName: string.isRequired,
  setReportName: func.isRequired,
  reportNameError: bool.isRequired,
  reportNameHelperText: string.isRequired,
  reportToClone: string,
  setReportToClone: func.isRequired,
  reportSchema: string.isRequired,
  setReportSchema: func.isRequired,
  setIsCloningExistingReport: func.isRequired
};

export default CreateReportForm;
